export default __webpack_public_path__ + "static/media/flag-dominican-republic.2f8b6e84.svg";